const a = "{{value, currency}}", t = "Qoldiq to'lov bilan kredit", i = "Qo'llash", n = "Chiqarib tashlash", r = { title: "Dasturni tanlang", empty: { title: "Afsuski, hech qanday kredit dasturi topilmadi", text: "Afsuski, biz siz tanlagan barcha mezonlarga mos keladigan natijalarni topa olmadik. Davom etish uchun ba'zi kredit parametrlarini o'zgartirishga urinib ko'ring" }, bank: "Bank", interestRate: "Stavka, % ", price: "Oyiga" }, e = { downPayment: "Dastlabki badal, %", residualPayment: "Qoldiq to'lov, %", creditTerm: "Kredit muddati, oy." }, s = {
  currency: a,
  residualPayment: t,
  confirm: i,
  reset: n,
  programs: r,
  sliders: e
};
export {
  i as confirm,
  a as currency,
  s as default,
  r as programs,
  n as reset,
  t as residualPayment,
  e as sliders
};
